<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.saleAgentRequest') }}
        </div>

        <sale-agent-request-list-view
            class="saleAgentRequestListView"
            :saleAgentRequests="requestlist"
            :pagination="pagination"/>

        <v-pagination
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="pagination.page"
            :length="pagination.pageTotal"
            :total-visible="pagination.pageTotalVisible"
            @input="onPaginationChanged"/>
    </v-container>
</template>

<script>
import SaleAgentRequestListView from '@/views/SaleAgentRequestListView'
import { mapState } from 'vuex'

export default {
    name: 'SaleAgentRequestListPage',

    components: {
        SaleAgentRequestListView
    },

    data () {
        return {
            saleAgentRequests: [],
            pagination: {
                page: 1,
                pageTotal: 1,
                pageTotalVisible: 1,
                itemsPerPage: 50,
                dateRange: [],
                search: '',
                approveStatus: 'all'
            }
        }
    },

    computed: {
        ...mapState('saleagentRequestList', ['requestlist'])
    },

    mounted () {
        this.getSaleAgentRequestList()
    },

    methods: {
        getSaleAgentRequestList () {
            this.$store.dispatch('saleagentRequestList/fetchRequestlist')
                .then((e) => {
                    this.pagination.pageTotal = e
                    this.pagination.pageTotalVisible = e
                    console.log('this.pagination.pageTotal' + e)
                })
        },

        onPaginationChanged (e) {
            this.pagination.page = e
            this.$store.commit('saleagentRequestList/setPage', e - 1)
            this.$store.dispatch('saleagentRequestList/fetchRequestlist')
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
